export default "__VITE_ASSET__BJXENXP4__"